import { BaseQueryApi } from '@reduxjs/toolkit/query'

import { tooltipAPI } from '@redux/api/tooltips.api'

import { ActionRow } from '@types'

type Props = {
  actions: ActionRow[]
  api: BaseQueryApi
}

export const fetchTooltipConfigsFromActions = async (props: Props) => {
  const { actions, api } = props

  const tooltipIds = Array.from(
    new Set(actions.filter(action => action.objectTooltipId).map(action => action.objectTooltipId))
  )

  const tooltipPromises = tooltipIds.map(async tooltipId => {
    const [tooltip, lines] = await Promise.all([
      api.dispatch(tooltipAPI.endpoints.fetchTooltipById.initiate(tooltipId as number)).unwrap(),
      api
        .dispatch(tooltipAPI.endpoints.fetchPointsLinesById.initiate(tooltipId as number))
        .unwrap(),
    ])

    return {
      ...tooltip,
      lines,
    }
  })

  const tooltips = await Promise.all(tooltipPromises)

  return new Map(tooltips.map((tooltip, index) => [tooltipIds[index], tooltip]))
}
